import { useMemo } from 'react';
import { IconReleased } from '@spotify-internal/encore-web';
import { TFunction, useT } from '@spotify-internal/i18n-core';
import { DateFilterOptions } from '@lib/api/artistWatchlist/types';
import { Dropdown, DropdownItem } from '@components/shared/Dropdown';

function getItems(t: TFunction): DropdownItem[] {
  return [
    {
      id: DateFilterOptions.LAST_24_HOURS,
      text: t(
        'atlas.held_releases.date_filter.last_24_hours',
        'Last 24 hours',
        'Last 24 hours option for date filter in Held in review tab',
      ),
    },
    {
      id: DateFilterOptions.LAST_7_DAYS,
      text: t(
        'atlas.held_releases.date_filter.last_7_days',
        'Last 7 days',
        'Last 7 days option for date filter in Held in review tab',
      ),
    },
    {
      id: DateFilterOptions.LAST_28_DAYS,
      text: t(
        'atlas.held_releases.date_filter.last_28_days',
        'Last 28 days',
        'Last 28 days option for date filter in Held in review tab',
      ),
    },
    {
      id: DateFilterOptions.SINCE_2023,
      text: t(
        'atlas.held_releases.date_filter.since_2023',
        'Since 2023',
        'Since 2023 option for date filter in Held in review tab',
      ),
    },
  ];
}

export const DEFAULT_DATE_FILTER_OPTION = DateFilterOptions.LAST_28_DAYS;

export const HeldReleasesFilter = ({
  onChangeDateFilter,
}: {
  onChangeDateFilter: (index: DateFilterOptions) => void;
}) => {
  const t = useT();
  const items = useMemo(() => getItems(t), [t]);

  const handleOnChangeFilter = (index: string) => {
    onChangeDateFilter(index as DateFilterOptions);
  };

  return (
    <Dropdown
      id="held-release-date-filter"
      onChange={handleOnChangeFilter}
      items={items}
      defaultId={DEFAULT_DATE_FILTER_OPTION}
      iconLeading={IconReleased}
    />
  );
};
